export const reflectivitywct = {
  'fill-color': {
    base: 1,
    type: 'exponential',
    property: 'value',
    stops: [
      [-23.5, 'rgb(0, 0, 0)'],
      [-19, 'rgb(50, 79, 79)'],
      [-14.5, 'rgb(102, 139, 139)'],
      [-10, 'rgb(150, 205, 205)'],
      [-5.5, 'rgb(174, 238, 238)'],
      [-1, 'rgb(187, 255, 255)'],
      [3.5, 'rgb(0, 236, 236)'],
      [8, 'rgb(1, 160, 246)'],
      [12.5, 'rgb(0, 0, 246)'],
      [17, 'rgb(0, 255, 0)'],
      [21.5, 'rgb(0, 200, 0)'],
      [26, 'rgb(0, 144, 0)'],
      [30.5, 'rgb(255, 255, 0)'],
      [35, 'rgb(231, 192, 0)'],
      [39.5, 'rgb(255, 144, 0)'],
      [44, 'rgb(255, 0, 0)'],
      [48.5, 'rgb(214, 0, 0)'],
      [53, 'rgb(192, 0, 0)'],
      [57.5, 'rgb(255, 0, 255)'],
      [62, 'rgb(153, 85, 201)'],
      [66.5, 'rgb(235, 235, 235)']
    ]
  }
};

export const reflectivity = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ -32.5, "rgb(131, 108, 146)" ],
      [ -32, "rgb(132, 110, 144)" ],
      [ -31, "rgb(133, 113, 143)" ],
      [ -30.5, "rgb(134, 115, 141)" ],
      [ -29.5, "rgb(135, 117, 139)" ],
      [ -29, "rgb(136, 119, 137)" ],
      [ -28, "rgb(137, 121, 135)" ],
      [ -27.5, "rgb(138, 123, 133)" ],
      [ -26.5, "rgb(139, 125, 132)" ],
      [ -26, "rgb(140, 127, 130)" ],
      [ -25.5, "rgb(141, 129, 128)" ],
      [ -24.5, "rgb(142, 131, 126)" ],
      [ -24, "rgb(143, 133, 124)" ],
      [ -23, "rgb(144, 135, 123)" ],
      [ -22.5, "rgb(145, 137, 121)" ],
      [ -21.5, "rgb(146, 139, 119)" ],
      [ -21, "rgb(147, 141, 117)" ],
      [ -20, "rgb(150, 145, 83)" ],
      [ -19.5, "rgb(152, 148, 87)" ],
      [ -19, "rgb(155, 151, 91)" ],
      [ -18.5, "rgb(157, 154, 96)" ],
      [ -18, "rgb(160, 157, 100)" ],
      [ -17.5, "rgb(165, 163, 109)" ],
      [ -17, "rgb(168, 166, 113)" ],
      [ -16.5, "rgb(170, 169, 118)" ],
      [ -16, "rgb(173, 172, 122)" ],
      [ -15.5, "rgb(176, 175, 126)" ],
      [ -15, "rgb(178, 178, 131)" ],
      [ -14.5, "rgb(181, 181, 135)" ],
      [ -14, "rgb(183, 184, 140)" ],
      [ -13.5, "rgb(186, 187, 144)" ],
      [ -13, "rgb(189, 190, 148)" ],
      [ -12.5, "rgb(191, 193, 153)" ],
      [ -12, "rgb(196, 199, 162)" ],
      [ -11.5, "rgb(199, 202, 166)" ],
      [ -11, "rgb(202, 205, 170)" ],
      [ -10.5, "rgb(204, 208, 175)" ],
      [ -10, "rgb(210, 212, 180)" ],
      [ -9.5, "rgb(207, 210, 180)" ],
      [ -9, "rgb(204, 207, 180)" ],
      [ -8.5, "rgb(201, 204, 180)" ],
      [ -8, "rgb(198, 201, 180)" ],
      [ -7.5, "rgb(195, 199, 180)" ],
      [ -7, "rgb(189, 193, 180)" ],
      [ -6.5, "rgb(185, 190, 180)" ],
      [ -6, "rgb(182, 187, 180)" ],
      [ -5.5, "rgb(179, 185, 180)" ],
      [ -5, "rgb(176, 182, 180)" ],
      [ -4.5, "rgb(173, 179, 180)" ],
      [ -4, "rgb(170, 176, 180)" ],
      [ -3.5, "rgb(167, 174, 180)" ],
      [ -3, "rgb(164, 171, 180)" ],
      [ -2.5, "rgb(160, 168, 180)" ],
      [ -2, "rgb(154, 162, 180)" ],
      [ -1.5, "rgb(151, 160, 180)" ],
      [ -1, "rgb(148, 157, 180)" ],
      [ -0.5, "rgb(145, 154, 180)" ],
      [ 0, "rgb(148, 155, 181)" ],
      [ 0.5, "rgb(144, 152, 180)" ],
      [ 1, "rgb(140, 149, 179)" ],
      [ 1.5, "rgb(136, 146, 178)" ],
      [ 2, "rgb(132, 143, 177)" ],
      [ 2.5, "rgb(128, 140, 176)" ],
      [ 3, "rgb(124, 137, 175)" ],
      [ 3.5, "rgb(120, 134, 174)" ],
      [ 4, "rgb(116, 131, 172)" ],
      [ 4.5, "rgb(112, 128, 171)" ],
      [ 5, "rgb(103, 121, 169)" ],
      [ 5.5, "rgb(99, 118, 168)" ],
      [ 6, "rgb(95, 115, 167)" ],
      [ 6.5, "rgb(91, 112, 166)" ],
      [ 7, "rgb(87, 109, 164)" ],
      [ 7.5, "rgb(83, 106, 163)" ],
      [ 8, "rgb(79, 103, 162)" ],
      [ 8.5, "rgb(75, 100, 161)" ],
      [ 9, "rgb(71, 97, 160)" ],
      [ 9.5, "rgb(67, 94, 159)" ],
      [ 10, "rgb(65, 91, 158)" ],
      [ 10.5, "rgb(67, 97, 162)" ],
      [ 11, "rgb(69, 104, 166)" ],
      [ 11.5, "rgb(72, 111, 170)" ],
      [ 12, "rgb(74, 118, 174)" ],
      [ 12.5, "rgb(79, 132, 182)" ],
      [ 13, "rgb(81, 139, 187)" ],
      [ 13.5, "rgb(84, 146, 191)" ],
      [ 14, "rgb(86, 153, 195)" ],
      [ 14.5, "rgb(89, 159, 199)" ],
      [ 15, "rgb(91, 166, 203)" ],
      [ 15.5, "rgb(94, 173, 207)" ],
      [ 16, "rgb(96, 180, 212)" ],
      [ 16.5, "rgb(98, 187, 216)" ],
      [ 17, "rgb(101, 194, 220)" ],
      [ 17.5, "rgb(106, 208, 228)" ],
      [ 18, "rgb(111, 214, 232)" ],
      [ 18.5, "rgb(104, 214, 215)" ],
      [ 19, "rgb(97, 214, 197)" ],
      [ 19.5, "rgb(89, 214, 179)" ],
      [ 20, "rgb(82, 214, 162)" ],
      [ 20.5, "rgb(75, 214, 144)" ],
      [ 21, "rgb(67, 214, 126)" ],
      [ 21.5, "rgb(60, 214, 109)" ],
      [ 22, "rgb(53, 214, 91)" ],
      [ 22.5, "rgb(17, 213, 24)" ],
      [ 23, "rgb(16, 205, 23)" ],
      [ 23.5, "rgb(16, 200, 22)" ],
      [ 24, "rgb(16, 196, 22)" ],
      [ 24.5, "rgb(15, 192, 21)" ],
      [ 25, "rgb(15, 188, 21)" ],
      [ 25.5, "rgb(15, 183, 20)" ],
      [ 26, "rgb(14, 179, 20)" ],
      [ 26.5, "rgb(14, 175, 19)" ],
      [ 27, "rgb(14, 171, 19)" ],
      [ 27.5, "rgb(13, 162, 18)" ],
      [ 28, "rgb(13, 158, 17)" ],
      [ 28.5, "rgb(12, 153, 17)" ],
      [ 29, "rgb(12, 149, 16)" ],
      [ 29.5, "rgb(12, 145, 16)" ],
      [ 30, "rgb(11, 141, 15)" ],
      [ 30.5, "rgb(11, 136, 15)" ],
      [ 31, "rgb(11, 132, 14)" ],
      [ 31.5, "rgb(10, 128, 14)" ],
      [ 32, "rgb(10, 124, 13)" ],
      [ 32.5, "rgb(9, 115, 12)" ],
      [ 33, "rgb(9, 111, 12)" ],
      [ 33.5, "rgb(9, 107, 11)" ],
      [ 34, "rgb(8, 102, 11)" ],
      [ 34.5, "rgb(8, 98, 10)" ],
      [ 35, "rgb(9, 94, 9)" ],
      [ 35.5, "rgb(29, 104, 9)" ],
      [ 36, "rgb(50, 115, 8)" ],
      [ 36.5, "rgb(70, 125, 8)" ],
      [ 37, "rgb(91, 136, 7)" ],
      [ 37.5, "rgb(132, 157, 6)" ],
      [ 38, "rgb(152, 168, 6)" ],
      [ 38.5, "rgb(173, 178, 5)" ],
      [ 39, "rgb(193, 189, 5)" ],
      [ 39.5, "rgb(214, 199, 4)" ],
      [ 40, "rgb(234, 210, 4)" ],
      [ 40.5, "rgb(255, 226, 0)" ],
      [ 41, "rgb(255, 221, 0)" ],
      [ 41.5, "rgb(255, 216, 0)" ],
      [ 42, "rgb(255, 211, 0)" ],
      [ 42.5, "rgb(255, 201, 0)" ],
      [ 43, "rgb(255, 196, 0)" ],
      [ 43.5, "rgb(255, 192, 0)" ],
      [ 44, "rgb(255, 187, 0)" ],
      [ 44.5, "rgb(255, 182, 0)" ],
      [ 45, "rgb(255, 177, 0)" ],
      [ 45.5, "rgb(255, 172, 0)" ],
      [ 46, "rgb(255, 167, 0)" ],
      [ 46.5, "rgb(255, 162, 0)" ],
      [ 47, "rgb(255, 158, 0)" ],
      [ 47.5, "rgb(255, 148, 0)" ],
      [ 48, "rgb(255, 143, 0)" ],
      [ 48.5, "rgb(255, 138, 0)" ],
      [ 49, "rgb(255, 133, 0)" ],
      [ 49.5, "rgb(255, 128, 0)" ],
      [ 50, "rgb(255, 0, 0)" ],
      [ 50.5, "rgb(248, 0, 0)" ],
      [ 51, "rgb(241, 0, 0)" ],
      [ 51.5, "rgb(234, 0, 0)" ],
      [ 52, "rgb(227, 0, 0)" ],
      [ 52.5, "rgb(220, 0, 0)" ],
      [ 53, "rgb(213, 0, 0)" ],
      [ 53.5, "rgb(205, 0, 0)" ],
      [ 54, "rgb(198, 0, 0)" ],
      [ 54.5, "rgb(191, 0, 0)" ],
      [ 55, "rgb(184, 0, 0)" ],
      [ 55.5, "rgb(170, 0, 0)" ],
      [ 56, "rgb(163, 0, 0)" ],
      [ 56.5, "rgb(155, 0, 0)" ],
      [ 57, "rgb(148, 0, 0)" ],
      [ 57.5, "rgb(141, 0, 0)" ],
      [ 58, "rgb(134, 0, 0)" ],
      [ 58.5, "rgb(127, 0, 0)" ],
      [ 59, "rgb(120, 0, 0)" ],
      [ 59.5, "rgb(113, 0, 0)" ],
      [ 60, "rgb(255, 255, 255)" ],
      [ 60.5, "rgb(255, 245, 255)" ],
      [ 61, "rgb(255, 234, 255)" ],
      [ 61.5, "rgb(255, 223, 255)" ],
      [ 62, "rgb(255, 212, 255)" ],
      [ 62.5, "rgb(255, 201, 255)" ],
      [ 63, "rgb(255, 179, 255)" ],
      [ 63.5, "rgb(255, 168, 255)" ],
      [ 64, "rgb(255, 157, 255)" ],
      [ 64.5, "rgb(255, 146, 255)" ],
      [ 65, "rgb(255, 117, 255)" ],
      [ 65.5, "rgb(252, 107, 253)" ],
      [ 66, "rgb(249, 96, 250)" ],
      [ 66.5, "rgb(246, 86, 247)" ],
      [ 67, "rgb(243, 75, 244)" ],
      [ 67.5, "rgb(237, 54, 239)" ],
      [ 68, "rgb(234, 43, 236)" ],
      [ 68.5, "rgb(231, 32, 233)" ],
      [ 69, "rgb(228, 22, 230)" ],
      [ 69.5, "rgb(225, 11, 227)" ],
      [ 70, "rgb(178, 0, 255)" ],
      [ 70.5, "rgb(172, 0, 252)" ],
      [ 71, "rgb(164, 0, 247)" ],
      [ 71.5, "rgb(155, 0, 244)" ],
      [ 72, "rgb(147, 0, 239)" ],
      [ 72.5, "rgb(136, 0, 234)" ],
      [ 73, "rgb(121, 0, 226)" ],
      [ 73.5, "rgb(114, 0, 221)" ],
      [ 74, "rgb(105, 0, 219)" ],
      [ 74.5, "rgb(99, 0, 214)" ],
      [ 75, "rgb(5, 236, 240)" ],
      [ 76, "rgb(5, 221, 224)" ],
      [ 77, "rgb(5, 205, 208)" ],
      [ 78.5, "rgb(4, 189, 192)" ],
      [ 80, "rgb(4, 174, 176)" ],
      [ 81, "rgb(4, 158, 160)" ],
      [ 82.5, "rgb(3, 142, 144)" ],
      [ 83.5, "rgb(3, 126, 128)" ],
      [ 85, "rgb(3, 111, 112)" ],
      [ 86.5, "rgb(2, 95, 96)" ],
      [ 87.5, "rgb(2, 79, 80)" ],
      [ 89, "rgb(2, 63, 64)" ],
      [ 90, "rgb(1, 48, 48)" ],
      [ 91.5, "rgb(1, 32, 32)" ],
      [ 93, "rgb(58, 103, 181)" ]
    ]
  }
};

export const velocity = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ -123.5, "rgb(138, 3, 147)" ],
      [ -123.4, "rgb(132, 4, 148)" ],
      [ -114.7, "rgb(126, 4, 149)" ],
      [ -108.8, "rgb(120, 4, 150)" ],
      [ -102.9, "rgb(114, 4, 151)" ],
      [ -99, "rgb(108, 4, 152)" ],
      [ -98.1, "rgb(93, 5, 153)" ],
      [ -97.1, "rgb(85, 5, 153)" ],
      [ -96.2, "rgb(77, 4, 153)" ],
      [ -95.2, "rgb(69, 4, 153)" ],
      [ -94.3, "rgb(61, 3, 153)" ],
      [ -93.3, "rgb(52, 3, 153)" ],
      [ -92.4, "rgb(44, 3, 153)" ],
      [ -91.4, "rgb(36, 2, 153)" ],
      [ -90.5, "rgb(28, 2, 153)" ],
      [ -89.5, "rgb(22, 2, 153)" ],
      [ -88.6, "rgb(22, 12, 156)" ],
      [ -87.6, "rgb(23, 23, 160)" ],
      [ -86.7, "rgb(24, 34, 163)" ],
      [ -85.7, "rgb(25, 44, 167)" ],
      [ -84.8, "rgb(26, 55, 170)" ],
      [ -83.8, "rgb(27, 66, 174)" ],
      [ -82.9, "rgb(28, 76, 177)" ],
      [ -81.9, "rgb(29, 87, 181)" ],
      [ -81, "rgb(30, 98, 184)" ],
      [ -80, "rgb(31, 108, 188)" ],
      [ -79, "rgb(32, 119, 192)" ],
      [ -78, "rgb(33, 130, 195)" ],
      [ -77, "rgb(34, 140, 199)" ],
      [ -76, "rgb(35, 151, 202)" ],
      [ -75, "rgb(36, 162, 206)" ],
      [ -74, "rgb(37, 172, 209)" ],
      [ -73, "rgb(38, 183, 213)" ],
      [ -72, "rgb(39, 194, 216)" ],
      [ -71, "rgb(40, 204, 220)" ],
      [ -70, "rgb(48, 224, 227)" ],
      [ -69, "rgb(52, 224, 227)" ],
      [ -68, "rgb(58, 224, 227)" ],
      [ -67, "rgb(65, 225, 228)" ],
      [ -66, "rgb(71, 226, 229)" ],
      [ -65, "rgb(78, 226, 229)" ],
      [ -64, "rgb(84, 227, 230)" ],
      [ -63, "rgb(91, 228, 231)" ],
      [ -62, "rgb(97, 229, 232)" ],
      [ -61, "rgb(104, 229, 232)" ],
      [ -60, "rgb(110, 230, 233)" ],
      [ -59.1, "rgb(117, 231, 234)" ],
      [ -58.1, "rgb(123, 231, 234)" ],
      [ -57.2, "rgb(130, 232, 235)" ],
      [ -56.2, "rgb(136, 233, 236)" ],
      [ -55.3, "rgb(143, 234, 237)" ],
      [ -54.4, "rgb(149, 234, 237)" ],
      [ -53.4, "rgb(156, 235, 238)" ],
      [ -52.5, "rgb(162, 236, 239)" ],
      [ -51.6, "rgb(169, 236, 239)" ],
      [ -50.6, "rgb(175, 237, 240)" ],
      [ -49.7, "rgb(182, 238, 241)" ],
      [ -48.8, "rgb(167, 241, 218)" ],
      [ -47.8, "rgb(154, 242, 200)" ],
      [ -46.9, "rgb(140, 243, 181)" ],
      [ -45.9, "rgb(127, 245, 163)" ],
      [ -45, "rgb(113, 246, 144)" ],
      [ -44, "rgb(100, 247, 126)" ],
      [ -43, "rgb(87, 248, 108)" ],
      [ -42, "rgb(73, 250, 89)" ],
      [ -41, "rgb(60, 251, 71)" ],
      [ -40, "rgb(46, 252, 52)" ],
      [ -39, "rgb(33, 253, 34)" ],
      [ -38, "rgb(3, 250, 3)" ],
      [ -37, "rgb(3, 245, 3)" ],
      [ -36, "rgb(3, 240, 3)" ],
      [ -35, "rgb(3, 234, 3)" ],
      [ -34, "rgb(3, 229, 3)" ],
      [ -33, "rgb(3, 224, 3)" ],
      [ -32, "rgb(3, 219, 3)" ],
      [ -31, "rgb(3, 213, 3)" ],
      [ -30, "rgb(3, 208, 3)" ],
      [ -29, "rgb(3, 203, 3)" ],
      [ -28, "rgb(3, 198, 3)" ],
      [ -27, "rgb(3, 192, 3)" ],
      [ -26, "rgb(3, 187, 3)" ],
      [ -25, "rgb(3, 182, 3)" ],
      [ -24, "rgb(3, 177, 3)" ],
      [ -23, "rgb(2, 171, 2)" ],
      [ -22, "rgb(2, 166, 2)" ],
      [ -21, "rgb(2, 161, 2)" ],
      [ -20, "rgb(2, 156, 2)" ],
      [ -19, "rgb(2, 150, 2)" ],
      [ -18.1, "rgb(2, 140, 2)" ],
      [ -17.1, "rgb(2, 135, 2)" ],
      [ -16.2, "rgb(2, 129, 2)" ],
      [ -15.2, "rgb(2, 124, 2)" ],
      [ -14.3, "rgb(2, 119, 2)" ],
      [ -13.3, "rgb(2, 114, 2)" ],
      [ -12.4, "rgb(2, 108, 2)" ],
      [ -11.4, "rgb(2, 103, 2)" ],
      [ -10.5, "rgb(5, 102, 3)" ],
      [ -9.5, "rgb(78, 121, 76)" ],
      [ -8.6, "rgb(82, 122, 80)" ],
      [ -7.6, "rgb(86, 124, 84)" ],
      [ -6.7, "rgb(90, 125, 88)" ],
      [ -5.7, "rgb(94, 126, 92)" ],
      [ -4.8, "rgb(98, 128, 96)" ],
      [ -3.8, "rgb(102, 129, 100)" ],
      [ -2.9, "rgb(106, 130, 104)" ],
      [ -1.9, "rgb(110, 132, 108)" ],
      [ -1, "rgb(114, 133, 112)" ],
      [ 0, "rgb(138, 118, 118)" ],
      [ 1, "rgb(138, 114, 129)" ],
      [ 1.9, "rgb(138, 108, 122)" ],
      [ 2.9, "rgb(137, 102, 115)" ],
      [ 3.8, "rgb(136, 95, 108)" ],
      [ 4.8, "rgb(136, 89, 101)" ],
      [ 5.7, "rgb(135, 82, 94)" ],
      [ 6.7, "rgb(134, 76, 86)" ],
      [ 7.6, "rgb(133, 69, 79)" ],
      [ 8.6, "rgb(133, 63, 72)" ],
      [ 9.5, "rgb(132, 56, 65)" ],
      [ 10.5, "rgb(110, 0, 0)" ],
      [ 11.4, "rgb(115, 0, 0)" ],
      [ 12.4, "rgb(121, 0, 0)" ],
      [ 13.3, "rgb(126, 0, 0)" ],
      [ 14.3, "rgb(132, 0, 1)" ],
      [ 15.2, "rgb(137, 0, 1)" ],
      [ 16.2, "rgb(143, 0, 1)" ],
      [ 17.1, "rgb(149, 0, 2)" ],
      [ 18.1, "rgb(160, 0, 2)" ],
      [ 19, "rgb(165, 0, 3)" ],
      [ 20, "rgb(171, 0, 3)" ],
      [ 21, "rgb(176, 0, 3)" ],
      [ 22, "rgb(182, 0, 4)" ],
      [ 23, "rgb(188, 0, 4)" ],
      [ 24, "rgb(193, 0, 4)" ],
      [ 25, "rgb(199, 0, 4)" ],
      [ 26, "rgb(204, 0, 5)" ],
      [ 27, "rgb(210, 0, 5)" ],
      [ 28, "rgb(215, 0, 5)" ],
      [ 29, "rgb(221, 0, 6)" ],
      [ 30, "rgb(227, 0, 6)" ],
      [ 31, "rgb(232, 0, 6)" ],
      [ 32, "rgb(238, 0, 7)" ],
      [ 33, "rgb(243, 0, 7)" ],
      [ 34, "rgb(250, 55, 81)" ],
      [ 35, "rgb(250, 60, 89)" ],
      [ 36, "rgb(250, 65, 97)" ],
      [ 37, "rgb(250, 71, 105)" ],
      [ 38, "rgb(251, 76, 113)" ],
      [ 39, "rgb(251, 82, 122)" ],
      [ 40, "rgb(251, 87, 130)" ],
      [ 41, "rgb(252, 93, 138)" ],
      [ 42, "rgb(252, 98, 146)" ],
      [ 43, "rgb(252, 104, 155)" ],
      [ 44, "rgb(252, 109, 163)" ],
      [ 45, "rgb(253, 115, 171)" ],
      [ 45.9, "rgb(253, 120, 179)" ],
      [ 46.9, "rgb(253, 126, 188)" ],
      [ 47.8, "rgb(254, 131, 196)" ],
      [ 48.8, "rgb(254, 137, 204)" ],
      [ 49.7, "rgb(255, 140, 213)" ],
      [ 50.6, "rgb(255, 149, 208)" ],
      [ 51.6, "rgb(255, 159, 203)" ],
      [ 52.5, "rgb(255, 168, 198)" ],
      [ 53.4, "rgb(255, 178, 193)" ],
      [ 54.4, "rgb(255, 187, 188)" ],
      [ 55.3, "rgb(255, 197, 183)" ],
      [ 56.2, "rgb(255, 206, 178)" ],
      [ 57.2, "rgb(255, 216, 173)" ],
      [ 58.1, "rgb(255, 225, 168)" ],
      [ 59.1, "rgb(255, 232, 163)" ],
      [ 60, "rgb(255, 228, 159)" ],
      [ 61, "rgb(255, 224, 155)" ],
      [ 62, "rgb(255, 219, 151)" ],
      [ 63, "rgb(255, 215, 147)" ],
      [ 64, "rgb(255, 211, 142)" ],
      [ 65, "rgb(255, 206, 138)" ],
      [ 66, "rgb(255, 202, 134)" ],
      [ 67, "rgb(255, 197, 130)" ],
      [ 68, "rgb(255, 193, 125)" ],
      [ 69, "rgb(255, 189, 121)" ],
      [ 70, "rgb(255, 184, 117)" ],
      [ 71, "rgb(255, 180, 113)" ],
      [ 72, "rgb(255, 176, 108)" ],
      [ 73, "rgb(255, 171, 104)" ],
      [ 74, "rgb(255, 167, 100)" ],
      [ 75, "rgb(255, 162, 96)" ],
      [ 76, "rgb(255, 158, 91)" ],
      [ 77, "rgb(255, 154, 87)" ],
      [ 78, "rgb(255, 149, 83)" ],
      [ 79, "rgb(255, 138, 79)" ],
      [ 80, "rgb(252, 135, 78)" ],
      [ 81, "rgb(248, 132, 76)" ],
      [ 81.9, "rgb(245, 129, 74)" ],
      [ 82.9, "rgb(241, 126, 72)" ],
      [ 83.8, "rgb(238, 123, 71)" ],
      [ 84.8, "rgb(234, 120, 69)" ],
      [ 85.7, "rgb(231, 117, 67)" ],
      [ 86.7, "rgb(227, 114, 65)" ],
      [ 87.6, "rgb(224, 111, 63)" ],
      [ 88.6, "rgb(220, 108, 62)" ],
      [ 89.5, "rgb(216, 104, 60)" ],
      [ 90.5, "rgb(213, 101, 58)" ],
      [ 91.4, "rgb(209, 98, 56)" ],
      [ 92.4, "rgb(206, 95, 54)" ],
      [ 93.3, "rgb(202, 92, 53)" ],
      [ 94.3, "rgb(199, 89, 51)" ],
      [ 95.2, "rgb(195, 86, 49)" ],
      [ 96.2, "rgb(192, 83, 47)" ],
      [ 97.1, "rgb(188, 80, 45)" ],
      [ 98.1, "rgb(185, 77, 44)" ],
      [ 99, "rgb(181, 74, 42)" ],
      [ 100, "rgb(177, 70, 40)" ],
      [ 103.9, "rgb(174, 67, 38)" ],
      [ 109.8, "rgb(170, 64, 36)" ],
      [ 116.6, "rgb(167, 61, 35)" ],
      [ 122.5, "rgb(163, 58, 33)" ],
      [ 800, "rgb(127, 0, 207)" ]
    ]
  }
};

export const correlationCoefficient = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0.2083, "rgb(30, 28, 141)" ],
      [ 0.225, "rgb(21, 19, 145)" ],
      [ 0.2417, "rgb(20, 18, 150)" ],
      [ 0.255, "rgb(19, 17, 155)" ],
      [ 0.2717, "rgb(18, 15, 161)" ],
      [ 0.2883, "rgb(17, 14, 166)" ],
      [ 0.3017, "rgb(16, 13, 171)" ],
      [ 0.3183, "rgb(15, 12, 176)" ],
      [ 0.335, "rgb(13, 10, 182)" ],
      [ 0.3517, "rgb(12, 9, 187)" ],
      [ 0.365, "rgb(11, 8, 192)" ],
      [ 0.3817, "rgb(10, 7, 197)" ],
      [ 0.3983, "rgb(9, 5, 203)" ],
      [ 0.4117, "rgb(8, 4, 208)" ],
      [ 0.4283, "rgb(7, 3, 213)" ],
      [ 0.445, "rgb(6, 2, 218)" ],
      [ 0.4583, "rgb(9, 2, 217)" ],
      [ 0.4717, "rgb(17, 10, 219)" ],
      [ 0.4817, "rgb(25, 18, 221)" ],
      [ 0.495, "rgb(33, 26, 224)" ],
      [ 0.5083, "rgb(41, 35, 226)" ],
      [ 0.5217, "rgb(49, 43, 228)" ],
      [ 0.5317, "rgb(57, 51, 231)" ],
      [ 0.545, "rgb(65, 60, 233)" ],
      [ 0.5583, "rgb(73, 68, 236)" ],
      [ 0.5717, "rgb(81, 76, 238)" ],
      [ 0.5817, "rgb(89, 85, 240)" ],
      [ 0.595, "rgb(97, 93, 243)" ],
      [ 0.6083, "rgb(105, 101, 245)" ],
      [ 0.6217, "rgb(113, 110, 247)" ],
      [ 0.6317, "rgb(121, 118, 250)" ],
      [ 0.645, "rgb(129, 126, 252)" ],
      [ 0.655, "rgb(137, 135, 255)" ],
      [ 0.6617, "rgb(135, 142, 245)" ],
      [ 0.6683, "rgb(132, 150, 235)" ],
      [ 0.675, "rgb(129, 157, 224)" ],
      [ 0.6783, "rgb(126, 165, 214)" ],
      [ 0.685, "rgb(123, 172, 204)" ],
      [ 0.6917, "rgb(121, 180, 193)" ],
      [ 0.6983, "rgb(118, 187, 183)" ],
      [ 0.705, "rgb(115, 195, 172)" ],
      [ 0.7117, "rgb(112, 202, 162)" ],
      [ 0.7183, "rgb(109, 210, 152)" ],
      [ 0.725, "rgb(107, 217, 141)" ],
      [ 0.7283, "rgb(104, 225, 131)" ],
      [ 0.735, "rgb(101, 232, 121)" ],
      [ 0.7417, "rgb(98, 240, 110)" ],
      [ 0.7483, "rgb(95, 247, 100)" ],
      [ 0.755, "rgb(92, 255, 89)" ],
      [ 0.7617, "rgb(94, 252, 84)" ],
      [ 0.7683, "rgb(97, 249, 79)" ],
      [ 0.775, "rgb(100, 246, 73)" ],
      [ 0.7783, "rgb(103, 243, 68)" ],
      [ 0.785, "rgb(106, 240, 62)" ],
      [ 0.7917, "rgb(109, 237, 57)" ],
      [ 0.7983, "rgb(112, 234, 51)" ],
      [ 0.805, "rgb(115, 231, 46)" ],
      [ 0.8117, "rgb(117, 228, 41)" ],
      [ 0.8183, "rgb(120, 225, 35)" ],
      [ 0.825, "rgb(123, 222, 30)" ],
      [ 0.8283, "rgb(126, 219, 24)" ],
      [ 0.835, "rgb(129, 216, 19)" ],
      [ 0.8417, "rgb(132, 213, 13)" ],
      [ 0.8483, "rgb(135, 210, 8)" ],
      [ 0.8517, "rgb(138, 207, 2)" ],
      [ 0.855, "rgb(145, 209, 2)" ],
      [ 0.8583, "rgb(152, 212, 2)" ],
      [ 0.8617, "rgb(159, 215, 2)" ],
      [ 0.865, "rgb(167, 218, 2)" ],
      [ 0.8683, "rgb(174, 220, 2)" ],
      [ 0.8717, "rgb(181, 223, 2)" ],
      [ 0.875, "rgb(189, 226, 2)" ],
      [ 0.8783, "rgb(196, 229, 2)" ],
      [ 0.8817, "rgb(203, 231, 2)" ],
      [ 0.885, "rgb(211, 234, 2)" ],
      [ 0.8883, "rgb(218, 237, 2)" ],
      [ 0.8917, "rgb(225, 240, 2)" ],
      [ 0.895, "rgb(233, 242, 2)" ],
      [ 0.8983, "rgb(240, 245, 2)" ],
      [ 0.9017, "rgb(255, 251, 3)" ],
      [ 0.905, "rgb(255, 245, 3)" ],
      [ 0.9083, "rgb(255, 241, 3)" ],
      [ 0.9117, "rgb(255, 234, 3)" ],
      [ 0.915, "rgb(255, 227, 2)" ],
      [ 0.9183, "rgb(255, 221, 2)" ],
      [ 0.9217, "rgb(255, 214, 1)" ],
      [ 0.925, "rgb(255, 210, 1)" ],
      [ 0.9283, "rgb(255, 203, 1)" ],
      [ 0.9317, "rgb(255, 196, 0)" ],
      [ 0.935, "rgb(255, 189, 0)" ],
      [ 0.9383, "rgb(255, 178, 0)" ],
      [ 0.9417, "rgb(255, 171, 1)" ],
      [ 0.945, "rgb(255, 160, 1)" ],
      [ 0.9483, "rgb(255, 149, 2)" ],
      [ 0.9517, "rgb(255, 132, 3)" ],
      [ 0.955, "rgb(255, 102, 2)" ],
      [ 0.9583, "rgb(255, 73, 1)" ],
      [ 0.9617, "rgb(254, 41, 0)" ],
      [ 0.965, "rgb(244, 27, 0)" ],
      [ 0.9683, "rgb(234, 14, 0)" ],
      [ 0.9717, "rgb(223, 0, 0)" ],
      [ 0.975, "rgb(203, 0, 0)" ],
      [ 0.9783, "rgb(182, 0, 0)" ],
      [ 0.9817, "rgb(161, 0, 6)" ],
      [ 0.985, "rgb(158, 0, 37)" ],
      [ 0.9883, "rgb(155, 0, 74)" ],
      [ 0.9917, "rgb(149, 8, 84)" ],
      [ 0.995, "rgb(145, 17, 81)" ],
      [ 0.9983, "rgb(141, 26, 78)" ],
      [ 1.0017, "rgb(250, 172, 209)" ],
      [ 1.005, "rgb(238, 156, 201)" ],
      [ 1.0083, "rgb(233, 148, 197)" ],
      [ 1.0117, "rgb(221, 133, 189)" ],
      [ 1.015, "rgb(216, 125, 185)" ],
      [ 1.0183, "rgb(210, 117, 181)" ],
      [ 1.0217, "rgb(198, 101, 173)" ],
      [ 1.025, "rgb(193, 93, 169)" ],
      [ 1.0283, "rgb(190, 89, 167)" ],
      [ 1.0317, "rgb(187, 86, 165)" ],
      [ 1.035, "rgb(181, 78, 161)" ],
      [ 1.0383, "rgb(178, 74, 159)" ],
      [ 1.0417, "rgb(176, 70, 157)" ],
      [ 1.045, "rgb(170, 62, 153)" ],
      [ 1.0483, "rgb(167, 58, 151)" ]
    ]
  }
};

export const spectrumWidth = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0, "rgb(4, 142, 222)" ],
      [ 0.972, "rgb(4, 4, 4)" ],
      [ 1.944, "rgb(32, 31, 32)" ],
      [ 2.916, "rgb(51, 50, 50)" ],
      [ 3.888, "rgb(65, 63, 64)" ],
      [ 4.86, "rgb(83, 81, 83)" ],
      [ 5.832, "rgb(102, 100, 101)" ],
      [ 6.804, "rgb(120, 118, 120)" ],
      [ 7.776, "rgb(139, 136, 138)" ],
      [ 8.748, "rgb(158, 154, 157)" ],
      [ 9.72, "rgb(176, 172, 175)" ],
      [ 10.692, "rgb(237, 210, 2)" ],
      [ 11.664, "rgb(237, 162, 2)" ],
      [ 12.636, "rgb(237, 124, 1)" ],
      [ 13.608, "rgb(237, 95, 1)" ],
      [ 14.58, "rgb(237, 67, 1)" ],
      [ 15.552, "rgb(223, 39, 0)" ],
      [ 16.524, "rgb(204, 28, 0)" ],
      [ 17.496, "rgb(185, 17, 0)" ],
      [ 18.468, "rgb(166, 6, 0)" ],
      [ 19.44, "rgb(255, 13, 210)" ],
      [ 20.412, "rgb(255, 54, 217)" ],
      [ 21.384, "rgb(255, 68, 220)" ],
      [ 22.356, "rgb(255, 81, 222)" ],
      [ 23.328, "rgb(255, 109, 227)" ],
      [ 24.3, "rgb(255, 122, 229)" ],
      [ 25.272, "rgb(255, 136, 232)" ],
      [ 26.244, "rgb(255, 150, 234)" ],
      [ 27.216, "rgb(255, 163, 236)" ],
      [ 28.188, "rgb(255, 177, 239)" ],
      [ 29.16, "rgb(255, 191, 241)" ],
      [ 30.132, "rgb(255, 204, 244)" ],
      [ 31.104, "rgb(255, 218, 246)" ],
      [ 32.076, "rgb(230, 252, 245)" ],
      [ 33.048, "rgb(222, 252, 245)" ],
      [ 34.02, "rgb(214, 252, 245)" ],
      [ 34.992, "rgb(205, 252, 245)" ],
      [ 36.936, "rgb(197, 252, 245)" ],
      [ 38.88, "rgb(189, 252, 245)" ],
      [ 800, "rgb(103, 0, 158)" ]
    ]
  }
};

export const enhancedEchoTops = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0, "rgb(119, 119, 119)" ],
      [ 6, "rgb(18, 226, 254)" ],
      [ 12, "rgb(10, 202, 254)" ],
      [ 13, "rgb(3, 178, 254)" ],
      [ 19, "rgb(2, 144, 206)" ],
      [ 25, "rgb(50, 0, 149)" ],
      [ 31, "rgb(3, 251, 143)" ],
      [ 37, "rgb(2, 219, 72)" ],
      [ 38, "rgb(2, 188, 2)" ],
      [ 44, "rgb(2, 239, 2)" ],
      [ 50, "rgb(254, 186, 0)" ],
      [ 56, "rgb(254, 250, 3)" ],
      [ 61, "rgb(214, 125, 1)" ],
      [ 62, "rgb(175, 0, 0)" ],
      [ 66, "rgb(254, 0, 0)" ]
    ]
  }
};

export const digitalVIL = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0, "rgb(165, 165, 165)" ],
      [ 0.01, "rgb(164, 165, 165)" ],
      [ 0.02, "rgb(164, 165, 165)" ],
      [ 0.03, "rgb(162, 165, 165)" ],
      [ 0.04, "rgb(162, 166, 166)" ],
      [ 0.06, "rgb(163, 168, 168)" ],
      [ 0.07, "rgb(161, 168, 168)" ],
      [ 0.08, "rgb(160, 168, 168)" ],
      [ 0.09, "rgb(159, 168, 168)" ],
      [ 0.1, "rgb(158, 168, 168)" ],
      [ 0.1079, "rgb(158, 169, 169)" ],
      [ 0.1165, "rgb(158, 170, 170)" ],
      [ 0.1257, "rgb(157, 170, 170)" ],
      [ 0.1356, "rgb(155, 170, 170)" ],
      [ 0.1464, "rgb(154, 170, 170)" ],
      [ 0.1579, "rgb(153, 170, 170)" ],
      [ 0.1704, "rgb(154, 173, 173)" ],
      [ 0.1839, "rgb(153, 173, 173)" ],
      [ 0.1985, "rgb(152, 173, 173)" ],
      [ 0.2035, "rgb(151, 173, 173)" ],
      [ 0.2086, "rgb(150, 173, 173)" ],
      [ 0.2139, "rgb(150, 173, 173)" ],
      [ 0.2193, "rgb(151, 175, 175)" ],
      [ 0.2249, "rgb(150, 175, 175)" ],
      [ 0.2306, "rgb(149, 175, 175)" ],
      [ 0.2364, "rgb(147, 175, 175)" ],
      [ 0.2424, "rgb(146, 175, 175)" ],
      [ 0.2485, "rgb(146, 176, 176)" ],
      [ 0.2548, "rgb(146, 178, 178)" ],
      [ 0.2612, "rgb(144, 178, 178)" ],
      [ 0.2678, "rgb(143, 178, 178)" ],
      [ 0.2746, "rgb(142, 178, 178)" ],
      [ 0.2815, "rgb(141, 178, 178)" ],
      [ 0.2887, "rgb(141, 179, 179)" ],
      [ 0.296, "rgb(141, 181, 181)" ],
      [ 0.3034, "rgb(139, 181, 181)" ],
      [ 0.3111, "rgb(138, 181, 181)" ],
      [ 0.319, "rgb(137, 181, 181)" ],
      [ 0.3271, "rgb(135, 181, 181)" ],
      [ 0.3353, "rgb(135, 183, 183)" ],
      [ 0.3438, "rgb(134, 183, 183)" ],
      [ 0.3525, "rgb(134, 183, 183)" ],
      [ 0.3614, "rgb(132, 183, 183)" ],
      [ 0.3705, "rgb(132, 184, 184)" ],
      [ 0.3799, "rgb(132, 186, 186)" ],
      [ 0.3895, "rgb(130, 186, 186)" ],
      [ 0.3994, "rgb(129, 186, 186)" ],
      [ 0.4095, "rgb(128, 186, 186)" ],
      [ 0.4198, "rgb(126, 186, 186)" ],
      [ 0.4304, "rgb(126, 187, 187)" ],
      [ 0.4413, "rgb(126, 188, 188)" ],
      [ 0.4525, "rgb(124, 188, 188)" ],
      [ 0.4639, "rgb(122, 188, 188)" ],
      [ 0.4756, "rgb(121, 188, 188)" ],
      [ 0.4877, "rgb(120, 188, 188)" ],
      [ 0.5, "rgb(120, 191, 191)" ],
      [ 0.51, "rgb(119, 191, 191)" ],
      [ 0.53, "rgb(118, 191, 191)" ],
      [ 0.54, "rgb(117, 191, 191)" ],
      [ 0.55, "rgb(116, 191, 191)" ],
      [ 0.57, "rgb(116, 191, 191)" ],
      [ 0.58, "rgb(114, 191, 191)" ],
      [ 0.6, "rgb(114, 192, 192)" ],
      [ 0.61, "rgb(114, 193, 193)" ],
      [ 0.63, "rgb(112, 193, 193)" ],
      [ 0.65, "rgb(110, 193, 193)" ],
      [ 0.66, "rgb(109, 194, 194)" ],
      [ 0.68, "rgb(109, 196, 196)" ],
      [ 0.7, "rgb(107, 196, 196)" ],
      [ 0.72, "rgb(106, 196, 196)" ],
      [ 0.73, "rgb(106, 196, 196)" ],
      [ 0.75, "rgb(104, 196, 196)" ],
      [ 0.77, "rgb(103, 197, 197)" ],
      [ 0.79, "rgb(103, 198, 198)" ],
      [ 0.81, "rgb(101, 198, 198)" ],
      [ 0.84, "rgb(100, 198, 198)" ],
      [ 0.86, "rgb(99, 198, 198)" ],
      [ 0.88, "rgb(97, 198, 198)" ],
      [ 0.9, "rgb(96, 199, 199)" ],
      [ 0.93, "rgb(96, 201, 201)" ],
      [ 0.95, "rgb(94, 201, 201)" ],
      [ 0.97, "rgb(92, 201, 201)" ],
      [ 1, "rgb(91, 202, 202)" ],
      [ 1.03, "rgb(91, 204, 204)" ],
      [ 1.05, "rgb(89, 204, 204)" ],
      [ 1.08, "rgb(88, 204, 204)" ],
      [ 1.11, "rgb(87, 204, 204)" ],
      [ 1.14, "rgb(85, 204, 204)" ],
      [ 1.17, "rgb(84, 205, 205)" ],
      [ 1.2, "rgb(84, 206, 206)" ],
      [ 1.23, "rgb(82, 206, 206)" ],
      [ 1.26, "rgb(81, 206, 206)" ],
      [ 1.29, "rgb(80, 206, 206)" ],
      [ 1.33, "rgb(78, 206, 206)" ],
      [ 1.36, "rgb(77, 209, 209)" ],
      [ 1.4, "rgb(76, 209, 209)" ],
      [ 1.43, "rgb(75, 209, 209)" ],
      [ 1.47, "rgb(73, 209, 209)" ],
      [ 1.51, "rgb(72, 209, 209)" ],
      [ 1.55, "rgb(72, 209, 209)" ],
      [ 1.59, "rgb(71, 209, 209)" ],
      [ 1.63, "rgb(70, 210, 210)" ],
      [ 1.67, "rgb(69, 211, 211)" ],
      [ 1.71, "rgb(67, 211, 211)" ],
      [ 1.76, "rgb(66, 211, 211)" ],
      [ 1.8, "rgb(65, 211, 211)" ],
      [ 1.85, "rgb(64, 214, 214)" ],
      [ 1.9, "rgb(62, 214, 214)" ],
      [ 1.95, "rgb(60, 214, 214)" ],
      [ 2, "rgb(59, 214, 214)" ],
      [ 2.05, "rgb(57, 214, 214)" ],
      [ 2.11, "rgb(56, 215, 215)" ],
      [ 2.16, "rgb(56, 216, 216)" ],
      [ 2.22, "rgb(54, 216, 216)" ],
      [ 2.28, "rgb(53, 216, 216)" ],
      [ 2.34, "rgb(52, 216, 216)" ],
      [ 2.4, "rgb(49, 216, 216)" ],
      [ 2.47, "rgb(48, 217, 217)" ],
      [ 2.53, "rgb(48, 219, 219)" ],
      [ 2.6, "rgb(46, 219, 219)" ],
      [ 2.67, "rgb(43, 219, 219)" ],
      [ 2.74, "rgb(42, 219, 219)" ],
      [ 2.81, "rgb(41, 219, 219)" ],
      [ 2.89, "rgb(39, 221, 221)" ],
      [ 2.96, "rgb(38, 221, 221)" ],
      [ 3.04, "rgb(37, 221, 221)" ],
      [ 3.12, "rgb(35, 221, 221)" ],
      [ 3.2, "rgb(34, 222, 222)" ],
      [ 3.29, "rgb(33, 224, 224)" ],
      [ 3.38, "rgb(31, 224, 224)" ],
      [ 3.47, "rgb(30, 224, 224)" ],
      [ 3.56, "rgb(29, 224, 224)" ],
      [ 3.65, "rgb(26, 224, 224)" ],
      [ 3.75, "rgb(24, 226, 226)" ],
      [ 3.85, "rgb(23, 226, 226)" ],
      [ 3.95, "rgb(22, 226, 226)" ],
      [ 4.06, "rgb(20, 226, 226)" ],
      [ 4.16, "rgb(19, 226, 226)" ],
      [ 4.27, "rgb(19, 226, 226)" ],
      [ 4.39, "rgb(18, 226, 226)" ],
      [ 4.5, "rgb(17, 227, 227)" ],
      [ 4.62, "rgb(16, 229, 229)" ],
      [ 4.74, "rgb(13, 229, 229)" ],
      [ 4.87, "rgb(12, 229, 229)" ],
      [ 5, "rgb(11, 229, 229)" ],
      [ 5.13, "rgb(3, 167, 255)" ],
      [ 5.26, "rgb(3, 163, 254)" ],
      [ 5.4, "rgb(3, 160, 253)" ],
      [ 5.54, "rgb(3, 156, 251)" ],
      [ 5.68, "rgb(3, 152, 250)" ],
      [ 5.83, "rgb(3, 148, 248)" ],
      [ 5.98, "rgb(3, 145, 247)" ],
      [ 6.14, "rgb(3, 141, 245)" ],
      [ 6.3, "rgb(3, 137, 244)" ],
      [ 6.46, "rgb(3, 133, 242)" ],
      [ 6.63, "rgb(3, 130, 241)" ],
      [ 6.8, "rgb(3, 125, 239)" ],
      [ 6.98, "rgb(3, 122, 238)" ],
      [ 7.16, "rgb(3, 118, 236)" ],
      [ 7.35, "rgb(3, 114, 235)" ],
      [ 7.54, "rgb(3, 110, 233)" ],
      [ 7.74, "rgb(3, 107, 232)" ],
      [ 7.94, "rgb(3, 103, 230)" ],
      [ 8.14, "rgb(3, 99, 229)" ],
      [ 8.36, "rgb(3, 95, 227)" ],
      [ 8.57, "rgb(3, 92, 226)" ],
      [ 8.8, "rgb(3, 88, 224)" ],
      [ 9.02, "rgb(3, 84, 223)" ],
      [ 9.26, "rgb(3, 80, 222)" ],
      [ 9.5, "rgb(3, 76, 221)" ],
      [ 9.75, "rgb(3, 72, 219)" ],
      [ 10, "rgb(3, 69, 218)" ],
      [ 10.26, "rgb(3, 65, 216)" ],
      [ 10.53, "rgb(3, 61, 215)" ],
      [ 10.8, "rgb(3, 57, 213)" ],
      [ 11.08, "rgb(3, 54, 212)" ],
      [ 11.37, "rgb(3, 50, 210)" ],
      [ 11.67, "rgb(3, 46, 209)" ],
      [ 11.97, "rgb(3, 41, 207)" ],
      [ 12.28, "rgb(3, 38, 206)" ],
      [ 12.6, "rgb(3, 34, 204)" ],
      [ 12.93, "rgb(3, 31, 203)" ],
      [ 13.26, "rgb(3, 27, 201)" ],
      [ 13.61, "rgb(3, 23, 200)" ],
      [ 13.96, "rgb(3, 19, 198)" ],
      [ 14.32, "rgb(3, 16, 197)" ],
      [ 14.7, "rgb(3, 12, 195)" ],
      [ 15.08, "rgb(3, 8, 194)" ],
      [ 15.47, "rgb(9, 131, 101)" ],
      [ 15.87, "rgb(5, 255, 34)" ],
      [ 16.29, "rgb(16, 255, 8)" ],
      [ 16.71, "rgb(16, 252, 8)" ],
      [ 17.14, "rgb(16, 247, 8)" ],
      [ 17.59, "rgb(15, 241, 8)" ],
      [ 18.05, "rgb(15, 235, 8)" ],
      [ 18.52, "rgb(14, 227, 8)" ],
      [ 19, "rgb(14, 222, 8)" ],
      [ 19.49, "rgb(13, 215, 7)" ],
      [ 20, "rgb(13, 210, 7)" ],
      [ 20.52, "rgb(12, 202, 7)" ],
      [ 21.05, "rgb(11, 195, 7)" ],
      [ 21.6, "rgb(11, 190, 7)" ],
      [ 22.16, "rgb(11, 184, 6)" ],
      [ 22.74, "rgb(10, 178, 6)" ],
      [ 23.33, "rgb(10, 172, 6)" ],
      [ 23.94, "rgb(9, 166, 6)" ],
      [ 24.56, "rgb(9, 159, 6)" ],
      [ 25.2, "rgb(8, 153, 5)" ],
      [ 25.85, "rgb(8, 147, 5)" ],
      [ 26.53, "rgb(7, 141, 5)" ],
      [ 27.22, "rgb(7, 138, 5)" ],
      [ 27.92, "rgb(6, 131, 5)" ],
      [ 28.65, "rgb(6, 126, 5)" ],
      [ 29.39, "rgb(172, 202, 3)" ],
      [ 30.16, "rgb(255, 242, 3)" ],
      [ 30.94, "rgb(251, 230, 3)" ],
      [ 31.75, "rgb(248, 222, 3)" ],
      [ 32.57, "rgb(245, 214, 3)" ],
      [ 33.42, "rgb(242, 206, 3)" ],
      [ 34.29, "rgb(238, 196, 3)" ],
      [ 35.18, "rgb(235, 187, 3)" ],
      [ 36.1, "rgb(232, 178, 3)" ],
      [ 37.03, "rgb(229, 170, 3)" ],
      [ 38, "rgb(226, 161, 3)" ],
      [ 38.99, "rgb(224, 155, 3)" ],
      [ 40, "rgb(221, 147, 3)" ],
      [ 41.03, "rgb(218, 137, 3)" ],
      [ 42.08, "rgb(215, 131, 3)" ],
      [ 43.16, "rgb(212, 121, 3)" ],
      [ 44.27, "rgb(209, 113, 3)" ],
      [ 45.4, "rgb(232, 56, 1)" ],
      [ 46.57, "rgb(255, 0, 0)" ],
      [ 47.76, "rgb(254, 0, 0)" ],
      [ 48.99, "rgb(254, 0, 0)" ],
      [ 50.25, "rgb(243, 0, 0)" ],
      [ 51.54, "rgb(231, 0, 0)" ],
      [ 52.86, "rgb(222, 0, 0)" ],
      [ 54.22, "rgb(211, 0, 0)" ],
      [ 55.61, "rgb(200, 0, 0)" ],
      [ 57.03, "rgb(190, 0, 0)" ],
      [ 58.5, "rgb(179, 0, 0)" ],
      [ 60, "rgb(210, 0, 127)" ],
      [ 61.59, "rgb(251, 0, 255)" ],
      [ 63.22, "rgb(223, 15, 235)" ],
      [ 64.9, "rgb(203, 25, 221)" ],
      [ 66.62, "rgb(183, 36, 207)" ],
      [ 68.38, "rgb(161, 48, 191)" ],
      [ 70.19, "rgb(132, 63, 171)" ],
      [ 72.05, "rgb(252, 252, 252)" ],
      [ 73.96, "rgb(239, 239, 239)" ],
      [ 75.92, "rgb(216, 216, 216)" ],
      [ 77.93, "rgb(204, 204, 204)" ],
      [ 80, "rgb(168, 125, 45)" ]
    ]
  }
};

export const precipitationRate = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0.04, "rgb(110, 110, 110)" ],
      [ 0.08, "rgb(113, 113, 113)" ],
      [ 0.12, "rgb(116, 116, 116)" ],
      [ 0.16, "rgb(119, 119, 119)" ],
      [ 0.2, "rgb(122, 122, 122)" ],
      [ 0.24, "rgb(125, 125, 125)" ],
      [ 0.28, "rgb(128, 128, 128)" ],
      [ 0.32, "rgb(131, 131, 131)" ],
      [ 0.36, "rgb(134, 134, 134)" ],
      [ 0.4, "rgb(137, 137, 137)" ],
      [ 0.44, "rgb(140, 140, 140)" ],
      [ 0.48, "rgb(143, 143, 143)" ],
      [ 0.52, "rgb(146, 146, 146)" ],
      [ 0.56, "rgb(149, 149, 149)" ],
      [ 0.6, "rgb(152, 152, 152)" ],
      [ 0.64, "rgb(155, 155, 155)" ],
      [ 0.68, "rgb(158, 158, 158)" ],
      [ 0.72, "rgb(161, 161, 161)" ],
      [ 0.76, "rgb(164, 164, 164)" ],
      [ 0.8, "rgb(167, 167, 167)" ],
      [ 0.84, "rgb(170, 170, 170)" ],
      [ 0.88, "rgb(173, 173, 173)" ],
      [ 0.92, "rgb(176, 176, 176)" ],
      [ 0.96, "rgb(179, 179, 179)" ],
      [ 1, "rgb(182, 182, 182)" ],
      [ 1.04, "rgb(4, 0, 255)" ],
      [ 1.08, "rgb(4, 10, 255)" ],
      [ 1.12, "rgb(5, 20, 255)" ],
      [ 1.16, "rgb(6, 30, 255)" ],
      [ 1.2, "rgb(7, 40, 255)" ],
      [ 1.24, "rgb(8, 50, 255)" ],
      [ 1.28, "rgb(9, 60, 255)" ],
      [ 1.32, "rgb(10, 70, 255)" ],
      [ 1.36, "rgb(11, 80, 255)" ],
      [ 1.4, "rgb(12, 90, 255)" ],
      [ 1.44, "rgb(13, 100, 255)" ],
      [ 1.48, "rgb(14, 110, 255)" ],
      [ 1.52, "rgb(15, 120, 255)" ],
      [ 1.56, "rgb(16, 130, 255)" ],
      [ 1.6, "rgb(17, 140, 255)" ],
      [ 1.64, "rgb(18, 150, 255)" ],
      [ 1.68, "rgb(19, 160, 255)" ],
      [ 1.72, "rgb(20, 170, 255)" ],
      [ 1.76, "rgb(21, 180, 255)" ],
      [ 1.8, "rgb(22, 190, 255)" ],
      [ 1.84, "rgb(23, 200, 255)" ],
      [ 1.88, "rgb(24, 210, 255)" ],
      [ 1.92, "rgb(25, 220, 255)" ],
      [ 1.96, "rgb(26, 230, 255)" ],
      [ 2, "rgb(27, 240, 255)" ],
      [ 2.04, "rgb(10, 125, 14)" ],
      [ 2.08, "rgb(12, 130, 19)" ],
      [ 2.12, "rgb(15, 135, 25)" ],
      [ 2.16, "rgb(18, 140, 31)" ],
      [ 2.2, "rgb(21, 145, 37)" ],
      [ 2.24, "rgb(24, 151, 43)" ],
      [ 2.28, "rgb(27, 156, 49)" ],
      [ 2.32, "rgb(30, 161, 55)" ],
      [ 2.36, "rgb(33, 166, 61)" ],
      [ 2.4, "rgb(36, 171, 66)" ],
      [ 2.44, "rgb(39, 177, 72)" ],
      [ 2.48, "rgb(42, 182, 78)" ],
      [ 2.52, "rgb(45, 187, 84)" ],
      [ 2.56, "rgb(48, 192, 90)" ],
      [ 2.6, "rgb(51, 197, 96)" ],
      [ 2.64, "rgb(54, 203, 102)" ],
      [ 2.68, "rgb(57, 208, 108)" ],
      [ 2.72, "rgb(60, 213, 113)" ],
      [ 2.76, "rgb(63, 218, 119)" ],
      [ 2.8, "rgb(66, 223, 125)" ],
      [ 2.84, "rgb(69, 229, 131)" ],
      [ 2.88, "rgb(72, 234, 137)" ],
      [ 2.92, "rgb(75, 239, 143)" ],
      [ 2.96, "rgb(78, 244, 149)" ],
      [ 3., "rgb(81, 249, 155)" ],
      [ 3.04, "rgb(178, 0, 181)" ],
      [ 3.08, "rgb(181, 6, 184)" ],
      [ 3.12, "rgb(184, 12, 187)" ],
      [ 3.16, "rgb(187, 19, 190)" ],
      [ 3.2, "rgb(190, 25, 193)" ],
      [ 3.24, "rgb(194, 31, 196)" ],
      [ 3.28, "rgb(197, 38, 199)" ],
      [ 3.32, "rgb(200, 44, 202)" ],
      [ 3.36, "rgb(203, 51, 205)" ],
      [ 3.4, "rgb(206, 57, 208)" ],
      [ 3.44, "rgb(210, 63, 211)" ],
      [ 3.48, "rgb(213, 70, 214)" ],
      [ 3.52, "rgb(216, 76, 218)" ],
      [ 3.56, "rgb(219, 82, 221)" ],
      [ 3.6, "rgb(222, 89, 224)" ],
      [ 3.64, "rgb(226, 95, 227)" ],
      [ 3.68, "rgb(229, 102, 230)" ],
      [ 3.72, "rgb(232, 108, 233)" ],
      [ 3.76, "rgb(235, 114, 236)" ],
      [ 3.8, "rgb(238, 121, 239)" ],
      [ 3.84, "rgb(242, 127, 242)" ],
      [ 3.88, "rgb(245, 133, 245)" ],
      [ 3.92, "rgb(248, 140, 248)" ],
      [ 3.96, "rgb(251, 146, 251)" ],
      [ 4., "rgb(255, 251, 3)" ],
      [ 4.04, "rgb(255, 249, 3)" ],
      [ 4.08, "rgb(255, 246, 3)" ],
      [ 4.12, "rgb(255, 244, 3)" ],
      [ 4.16, "rgb(255, 241, 3)" ],
      [ 4.2, "rgb(255, 239, 3)" ],
      [ 4.24, "rgb(255, 236, 3)" ],
      [ 4.28, "rgb(255, 234, 3)" ],
      [ 4.32, "rgb(255, 231, 3)" ],
      [ 4.36, "rgb(255, 229, 3)" ],
      [ 4.4, "rgb(255, 226, 3)" ],
      [ 4.44, "rgb(255, 224, 3)" ],
      [ 4.48, "rgb(255, 221, 3)" ],
      [ 4.52, "rgb(255, 219, 3)" ],
      [ 4.56, "rgb(255, 216, 3)" ],
      [ 4.6, "rgb(255, 214, 3)" ],
      [ 4.64, "rgb(255, 211, 3)" ],
      [ 4.68, "rgb(255, 209, 3)" ],
      [ 4.72, "rgb(255, 206, 3)" ],
      [ 4.76, "rgb(255, 204, 3)" ],
      [ 4.8, "rgb(255, 201, 3)" ],
      [ 4.84, "rgb(255, 199, 3)" ],
      [ 4.88, "rgb(255, 196, 3)" ],
      [ 4.92, "rgb(255, 194, 3)" ],
      [ 4.96, "rgb(255, 191, 3)" ],
      [ 5., "rgb(255, 189, 3)" ],
      [ 5.04, "rgb(255, 186, 3)" ],
      [ 5.08, "rgb(255, 184, 3)" ],
      [ 5.12, "rgb(255, 181, 3)" ],
      [ 5.16, "rgb(255, 179, 3)" ],
      [ 5.2, "rgb(255, 176, 3)" ],
      [ 5.24, "rgb(255, 174, 3)" ],
      [ 5.28, "rgb(255, 171, 3)" ],
      [ 5.32, "rgb(255, 169, 3)" ],
      [ 5.36, "rgb(255, 166, 2)" ],
      [ 5.4, "rgb(255, 164, 2)" ],
      [ 5.44, "rgb(255, 161, 2)" ],
      [ 5.48, "rgb(255, 159, 2)" ],
      [ 5.52, "rgb(255, 156, 2)" ],
      [ 5.56, "rgb(255, 154, 2)" ],
      [ 5.6, "rgb(255, 151, 2)" ],
      [ 5.64, "rgb(255, 149, 2)" ],
      [ 5.68, "rgb(255, 146, 2)" ],
      [ 5.72, "rgb(255, 144, 2)" ],
      [ 5.76, "rgb(255, 141, 2)" ],
      [ 5.8, "rgb(255, 139, 2)" ],
      [ 5.84, "rgb(255, 136, 2)" ],
      [ 5.88, "rgb(255, 134, 2)" ],
      [ 5.92, "rgb(255, 131, 2)" ],
      [ 5.96, "rgb(255, 129, 2)" ],
      [ 6., "rgb(255, 126, 2)" ],
      [ 6.04, "rgb(255, 123, 2)" ],
      [ 6.08, "rgb(255, 121, 2)" ],
      [ 6.12, "rgb(255, 118, 2)" ],
      [ 6.16000000000001, "rgb(255, 116, 2)" ],
      [ 6.20000000000001, "rgb(255, 113, 2)" ],
      [ 6.24000000000001, "rgb(255, 111, 2)" ],
      [ 6.28000000000001, "rgb(255, 108, 2)" ],
      [ 6.32000000000001, "rgb(255, 106, 2)" ],
      [ 6.36000000000001, "rgb(255, 103, 2)" ],
      [ 6.40000000000001, "rgb(255, 101, 2)" ],
      [ 6.44000000000001, "rgb(255, 98, 2)" ],
      [ 6.48000000000001, "rgb(255, 96, 2)" ],
      [ 6.52000000000001, "rgb(255, 93, 2)" ],
      [ 6.56000000000001, "rgb(255, 91, 2)" ],
      [ 6.60000000000001, "rgb(255, 88, 2)" ],
      [ 6.64000000000001, "rgb(255, 86, 2)" ],
      [ 6.68000000000001, "rgb(255, 83, 1)" ],
      [ 6.72000000000001, "rgb(255, 81, 1)" ],
      [ 6.76000000000001, "rgb(255, 78, 1)" ],
      [ 6.80000000000001, "rgb(255, 76, 1)" ],
      [ 6.84000000000001, "rgb(255, 73, 1)" ],
      [ 6.88000000000001, "rgb(255, 71, 1)" ],
      [ 6.92000000000001, "rgb(255, 68, 1)" ],
      [ 6.96000000000001, "rgb(255, 66, 1)" ],
      [ 7.00000000000001, "rgb(255, 63, 1)" ],
      [ 7.037, "rgb(255, 61, 1)" ],
      [ 7.075, "rgb(255, 58, 1)" ],
      [ 7.113, "rgb(255, 56, 1)" ],
      [ 7.151, "rgb(255, 53, 1)" ],
      [ 7.189, "rgb(255, 51, 1)" ],
      [ 7.228, "rgb(255, 48, 1)" ],
      [ 7.267, "rgb(255, 46, 1)" ],
      [ 7.306, "rgb(255, 43, 1)" ],
      [ 7.345, "rgb(255, 41, 1)" ],
      [ 7.384, "rgb(255, 38, 1)" ],
      [ 7.424, "rgb(255, 36, 1)" ],
      [ 7.463, "rgb(255, 33, 1)" ],
      [ 7.503, "rgb(255, 31, 1)" ],
      [ 7.544, "rgb(255, 28, 1)" ],
      [ 7.584, "rgb(255, 26, 1)" ],
      [ 7.625, "rgb(255, 23, 1)" ],
      [ 7.665, "rgb(255, 21, 1)" ],
      [ 7.706, "rgb(255, 18, 1)" ],
      [ 7.748, "rgb(255, 16, 1)" ],
      [ 7.789, "rgb(255, 13, 1)" ],
      [ 7.831, "rgb(255, 11, 1)" ],
      [ 7.873, "rgb(255, 8, 1)" ],
      [ 7.915, "rgb(255, 6, 1)" ],
      [ 7.957, "rgb(255, 3, 1)" ],
      [ 8, "rgb(255, 168, 168)" ],
      [ 8.33, "rgb(255, 169, 169)" ],
      [ 8.68, "rgb(255, 171, 171)" ],
      [ 9.03, "rgb(255, 172, 172)" ],
      [ 9.41, "rgb(255, 174, 174)" ],
      [ 9.8, "rgb(255, 176, 176)" ],
      [ 10.2, "rgb(255, 177, 177)" ],
      [ 10.63, "rgb(255, 179, 179)" ],
      [ 11.07, "rgb(255, 180, 180)" ],
      [ 11.52, "rgb(255, 182, 182)" ],
      [ 12, "rgb(255, 184, 184)" ],
      [ 12.48, "rgb(255, 185, 185)" ],
      [ 12.98, "rgb(255, 187, 187)" ],
      [ 13.5, "rgb(255, 188, 188)" ],
      [ 14.04, "rgb(255, 190, 190)" ],
      [ 14.61, "rgb(255, 192, 192)" ],
      [ 15.19, "rgb(255, 193, 193)" ],
      [ 15.8, "rgb(255, 195, 195)" ],
      [ 16.43, "rgb(255, 197, 197)" ],
      [ 17.09, "rgb(255, 198, 198)" ],
      [ 17.78, "rgb(255, 200, 200)" ],
      [ 18.49, "rgb(255, 201, 201)" ],
      [ 19.23, "rgb(255, 203, 203)" ],
      [ 20, "rgb(255, 205, 205)" ],
      [ 21, "rgb(255, 206, 206)" ],
      [ 22, "rgb(255, 208, 208)" ],
      [ 23, "rgb(255, 209, 209)" ],
      [ 24, "rgb(255, 211, 211)" ],
      [ 25, "rgb(255, 213, 213)" ],
      [ 26, "rgb(255, 214, 214)" ],
      [ 27, "rgb(255, 216, 216)" ],
      [ 28, "rgb(255, 217, 217)" ],
      [ 29, "rgb(255, 219, 219)" ],
      [ 30, "rgb(255, 221, 221)" ],
      [ 31.2, "rgb(255, 222, 222)" ],
      [ 32.44, "rgb(255, 224, 224)" ],
      [ 33.73, "rgb(255, 226, 226)" ],
      [ 35.07, "rgb(255, 227, 227)" ],
      [ 36.47, "rgb(255, 229, 229)" ],
      [ 37.93, "rgb(255, 230, 230)" ],
      [ 39.44, "rgb(255, 232, 232)" ],
      [ 41.04, "rgb(255, 234, 234)" ],
      [ 42.64, "rgb(255, 235, 235)" ],
      [ 44.34, "rgb(255, 237, 237)" ],
      [ 46.11, "rgb(255, 238, 238)" ],
      [ 47.94, "rgb(255, 240, 240)" ],
      [ 49.85, "rgb(255, 242, 242)" ],
      [ 51.84, "rgb(255, 243, 243)" ],
      [ 53.91, "rgb(255, 245, 245)" ],
      [ 56.05, "rgb(255, 246, 246)" ],
      [ 58.29, "rgb(255, 248, 248)" ],
      [ 60.61, "rgb(255, 250, 250)" ],
      [ 63.02, "rgb(255, 251, 251)" ],
      [ 65.54, "rgb(255, 253, 253)" ]
    ]
  }
};

export const differentialPhaseShift = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ 0, "rgb(255, 255, 255)" ],
      [ 15, "rgb(210, 210, 180)" ],
      [ 30, "rgb(10, 20, 95)" ],
      [ 45, "rgb(0, 255, 0)" ],
      [ 60, "rgb(30, 100, 0)" ],
      [ 75, "rgb(255, 255, 0)" ],
      [ 90, "rgb(255, 125, 0)" ],
      [ 120, "rgb(90, 0, 0)" ],
      [ 180, "rgb(255, 140, 255)" ],
      [ 800, "rgb(119, 0, 125)" ]
    ]
  }
};

export const specificDifferentialPhase = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ -2, "rgb(119, 119, 119)" ],
      [ -1.95, "rgb(117, 117, 117)" ],
      [ -1.9, "rgb(115, 115, 115)" ],
      [ -1.8, "rgb(112, 112, 112)" ],
      [ -1.75, "rgb(109, 109, 109)" ],
      [ -1.7, "rgb(107, 107, 107)" ],
      [ -1.65, "rgb(104, 104, 104)" ],
      [ -1.55, "rgb(101, 101, 101)" ],
      [ -1.5, "rgb(99, 99, 99)" ],
      [ -1.45, "rgb(96, 96, 96)" ],
      [ -1.4, "rgb(93, 93, 93)" ],
      [ -1.3, "rgb(91, 91, 91)" ],
      [ -1.25, "rgb(88, 88, 88)" ],
      [ -1.2, "rgb(85, 85, 85)" ],
      [ -1.15, "rgb(83, 83, 83)" ],
      [ -1.05, "rgb(80, 80, 80)" ],
      [ -1, "rgb(77, 77, 77)" ],
      [ -0.95, "rgb(73, 73, 73)" ],
      [ -0.9, "rgb(71, 71, 71)" ],
      [ -0.85, "rgb(68, 68, 68)" ],
      [ -0.8, "rgb(66, 66, 66)" ],
      [ -0.75, "rgb(63, 63, 63)" ],
      [ -0.7, "rgb(58, 58, 58)" ],
      [ -0.65, "rgb(58, 58, 58)" ],
      [ -0.6, "rgb(53, 53, 53)" ],
      [ -0.55, "rgb(53, 53, 53)" ],
      [ -0.5, "rgb(74, 0, 0)" ],
      [ -0.45, "rgb(78, 0, 3)" ],
      [ -0.4, "rgb(81, 0, 5)" ],
      [ -0.35, "rgb(86, 0, 8)" ],
      [ -0.3, "rgb(88, 0, 10)" ],
      [ -0.25, "rgb(93, 0, 13)" ],
      [ -0.2, "rgb(98, 0, 17)" ],
      [ -0.15, "rgb(100, 0, 18)" ],
      [ -0.1, "rgb(105, 0, 22)" ],
      [ -0.05, "rgb(107, 0, 23)" ],
      [ 0, "rgb(112, 0, 27)" ],
      [ 0.05, "rgb(118, 0, 30)" ],
      [ 0.1, "rgb(128, 2, 33)" ],
      [ 0.15, "rgb(142, 3, 38)" ],
      [ 0.2, "rgb(152, 5, 41)" ],
      [ 0.25, "rgb(162, 6, 44)" ],
      [ 0.3, "rgb(169, 14, 53)" ],
      [ 0.35, "rgb(178, 26, 62)" ],
      [ 0.4, "rgb(191, 41, 74)" ],
      [ 0.45, "rgb(201, 53, 83)" ],
      [ 0.5, "rgb(210, 65, 92)" ],
      [ 0.55, "rgb(210, 66, 97)" ],
      [ 0.6, "rgb(212, 70, 103)" ],
      [ 0.65, "rgb(215, 77, 115)" ],
      [ 0.7, "rgb(217, 80, 121)" ],
      [ 0.75, "rgb(220, 87, 132)" ],
      [ 0.8, "rgb(223, 95, 144)" ],
      [ 0.85, "rgb(225, 98, 150)" ],
      [ 0.9, "rgb(228, 105, 161)" ],
      [ 0.95, "rgb(230, 109, 167)" ],
      [ 1, "rgb(233, 116, 179)" ],
      [ 1.05, "rgb(230, 120, 185)" ],
      [ 1.1, "rgb(225, 120, 185)" ],
      [ 1.15, "rgb(214, 121, 185)" ],
      [ 1.2, "rgb(209, 122, 185)" ],
      [ 1.25, "rgb(198, 123, 185)" ],
      [ 1.3, "rgb(187, 123, 185)" ],
      [ 1.35, "rgb(182, 124, 185)" ],
      [ 1.4, "rgb(171, 125, 185)" ],
      [ 1.45, "rgb(166, 125, 185)" ],
      [ 1.5, "rgb(155, 126, 185)" ],
      [ 1.55, "rgb(147, 135, 188)" ],
      [ 1.6, "rgb(144, 143, 192)" ],
      [ 1.65, "rgb(138, 159, 200)" ],
      [ 1.7, "rgb(135, 167, 204)" ],
      [ 1.75, "rgb(129, 183, 212)" ],
      [ 1.8, "rgb(123, 199, 221)" ],
      [ 1.85, "rgb(120, 207, 225)" ],
      [ 1.9, "rgb(114, 223, 233)" ],
      [ 1.95, "rgb(111, 231, 237)" ],
      [ 2, "rgb(105, 247, 245)" ],
      [ 2.05, "rgb(104, 244, 235)" ],
      [ 2.1, "rgb(99, 240, 223)" ],
      [ 2.15, "rgb(89, 232, 199)" ],
      [ 2.2, "rgb(84, 228, 187)" ],
      [ 2.25, "rgb(73, 221, 163)" ],
      [ 2.3, "rgb(63, 213, 138)" ],
      [ 2.35, "rgb(58, 209, 126)" ],
      [ 2.4, "rgb(47, 202, 102)" ],
      [ 2.45, "rgb(42, 198, 90)" ],
      [ 2.5, "rgb(32, 190, 66)" ],
      [ 2.55, "rgb(26, 190, 51)" ],
      [ 2.6, "rgb(26, 194, 49)" ],
      [ 2.65, "rgb(25, 203, 44)" ],
      [ 2.7, "rgb(24, 207, 42)" ],
      [ 2.75, "rgb(23, 216, 37)" ],
      [ 2.8, "rgb(23, 224, 32)" ],
      [ 2.85, "rgb(22, 229, 30)" ],
      [ 2.9, "rgb(21, 237, 25)" ],
      [ 2.95, "rgb(21, 242, 23)" ],
      [ 3, "rgb(20, 250, 18)" ],
      [ 3.05, "rgb(19, 255, 15)" ],
      [ 3.1, "rgb(48, 255, 14)" ],
      [ 3.2, "rgb(63, 255, 13)" ],
      [ 3.3, "rgb(78, 254, 12)" ],
      [ 3.35, "rgb(92, 254, 12)" ],
      [ 3.45, "rgb(107, 254, 11)" ],
      [ 3.5, "rgb(122, 254, 10)" ],
      [ 3.55, "rgb(137, 253, 9)" ],
      [ 3.6, "rgb(151, 253, 9)" ],
      [ 3.7, "rgb(166, 253, 8)" ],
      [ 3.75, "rgb(181, 253, 7)" ],
      [ 3.8, "rgb(196, 252, 6)" ],
      [ 3.85, "rgb(210, 252, 6)" ],
      [ 3.95, "rgb(225, 252, 5)" ],
      [ 4, "rgb(240, 252, 4)" ],
      [ 4.05, "rgb(255, 251, 3)" ],
      [ 4.1, "rgb(255, 243, 4)" ],
      [ 4.2, "rgb(255, 235, 5)" ],
      [ 4.25, "rgb(255, 227, 6)" ],
      [ 4.3, "rgb(255, 219, 8)" ],
      [ 4.35, "rgb(255, 211, 9)" ],
      [ 4.45, "rgb(255, 202, 10)" ],
      [ 4.5, "rgb(255, 194, 11)" ],
      [ 4.55, "rgb(255, 186, 13)" ],
      [ 4.6, "rgb(255, 178, 14)" ],
      [ 4.7, "rgb(255, 170, 15)" ],
      [ 4.75, "rgb(255, 161, 16)" ],
      [ 4.8, "rgb(255, 153, 18)" ],
      [ 4.85, "rgb(255, 145, 19)" ],
      [ 4.95, "rgb(255, 137, 20)" ],
      [ 5, "rgb(255, 129, 21)" ],
      [ 5.1, "rgb(255, 125, 18)" ],
      [ 5.2, "rgb(255, 129, 25)" ],
      [ 5.35, "rgb(255, 134, 32)" ],
      [ 5.45, "rgb(255, 139, 39)" ],
      [ 5.6, "rgb(255, 144, 46)" ],
      [ 5.7, "rgb(255, 149, 53)" ],
      [ 5.85, "rgb(255, 153, 61)" ],
      [ 5.95, "rgb(255, 158, 68)" ],
      [ 6.1, "rgb(255, 163, 75)" ],
      [ 6.2, "rgb(255, 168, 82)" ],
      [ 6.35, "rgb(255, 173, 89)" ],
      [ 6.45, "rgb(255, 177, 97)" ],
      [ 6.6, "rgb(255, 182, 104)" ],
      [ 6.7, "rgb(255, 187, 111)" ],
      [ 6.85, "rgb(255, 192, 118)" ],
      [ 6.95, "rgb(255, 197, 125)" ],
      [ 7.1, "rgb(255, 194, 125)" ],
      [ 7.3, "rgb(247, 182, 125)" ],
      [ 7.5, "rgb(238, 170, 125)" ],
      [ 7.7, "rgb(230, 158, 125)" ],
      [ 7.85, "rgb(221, 146, 125)" ],
      [ 8.05, "rgb(213, 134, 125)" ],
      [ 8.25, "rgb(204, 122, 125)" ],
      [ 8.45, "rgb(196, 110, 125)" ],
      [ 8.6, "rgb(187, 97, 125)" ],
      [ 8.8, "rgb(179, 85, 125)" ],
      [ 9, "rgb(170, 73, 125)" ],
      [ 9.2, "rgb(162, 61, 125)" ],
      [ 9.35, "rgb(153, 49, 125)" ],
      [ 9.55, "rgb(145, 37, 125)" ],
      [ 9.75, "rgb(136, 25, 125)" ],
      [ 9.95, "rgb(128, 13, 125)" ],
      [ 999, "rgb(119, 0, 125)" ]
    ]
  }
};

// export const differentialReflectivity = {
//   'fill-color': {
//     base: 1,
//     type: 'exponential',
//     property: 'value',
//     stops: [
//       [ -7.9, 'rgb(0, 0, 0)' ],
//       [ -0.01, 'rgb(220, 220, 220)' ],
//       [ 0, 'rgb(142, 121, 181)' ],
//       [ 0.25, 'rgb(10, 10, 155)' ],
//       [ 1.0, 'rgb(68, 248, 212)' ],
//       [ 1.5, 'rgb(90, 221, 98)' ],
//       [ 2.0, 'rgb(255, 255, 100)' ],
//       [ 3.0, 'rgb(220, 10, 5)' ],
//       [ 4.0, 'rgb(175, 0, 0)' ],
//       [ 5.0, 'rgb(240, 120, 180)' ],
//       [ 6.0, 'rgb(255, 255, 255)' ],
//       [ 7.9, 'rgb(145, 45, 150)' ]
//     ]
//   }
// };

export const differentialReflectivity = {
  "fill-color": {
    "base": 1,
    "type": "exponential",
    "property": "value",
    "stops": [
      [ -4.1, "rgb(61, 61, 61)" ],
      [ -4, "rgb(69, 69, 69)" ],
      [ -3.9, "rgb(74, 74, 74)" ],
      [ -3.8, "rgb(80, 80, 80)" ],
      [ -3.6, "rgb(85, 85, 85)" ],
      [ -3.5, "rgb(91, 91, 91)" ],
      [ -3.4, "rgb(96, 96, 96)" ],
      [ -3.3, "rgb(101, 101, 101)" ],
      [ -3.1, "rgb(107, 107, 107)" ],
      [ -3, "rgb(112, 112, 112)" ],
      [ -2.9, "rgb(118, 118, 118)" ],
      [ -2.8, "rgb(123, 123, 123)" ],
      [ -2.6, "rgb(128, 128, 128)" ],
      [ -2.5, "rgb(134, 134, 134)" ],
      [ -2.4, "rgb(139, 139, 139)" ],
      [ -2.3, "rgb(145, 145, 145)" ],
      [ -2.1, "rgb(150, 150, 150)" ],
      [ -2, "rgb(156, 156, 156)" ],
      [ -1.9, "rgb(158, 158, 158)" ],
      [ -1.8, "rgb(161, 161, 161)" ],
      [ -1.7, "rgb(164, 164, 164)" ],
      [ -1.6, "rgb(167, 167, 167)" ],
      [ -1.6, "rgb(170, 170, 170)" ],
      [ -1.5, "rgb(172, 172, 172)" ],
      [ -1.4, "rgb(175, 175, 175)" ],
      [ -1.3, "rgb(178, 178, 178)" ],
      [ -1.2, "rgb(181, 181, 181)" ],
      [ -1.1, "rgb(184, 184, 184)" ],
      [ -1, "rgb(186, 186, 186)" ],
      [ -0.9, "rgb(189, 189, 189)" ],
      [ -0.8, "rgb(192, 192, 192)" ],
      [ -0.7, "rgb(195, 195, 195)" ],
      [ -0.6, "rgb(198, 198, 198)" ],
      [ -0.5, "rgb(202, 202, 202)" ],
      [ -0.4, "rgb(205, 205, 205)" ],
      [ -0.3, "rgb(208, 208, 208)" ],
      [ -0.3, "rgb(211, 211, 211)" ],
      [ -0.2, "rgb(214, 214, 214)" ],
      [ -0.1, "rgb(220, 220, 220)" ],
      [ 0.1, "rgb(85, 72, 170)" ],
      [ 0.2, "rgb(44, 36, 162)" ],
      [ 0.3, "rgb(9, 28, 164)" ],
      [ 0.4, "rgb(24, 96, 189)" ],
      [ 0.5, "rgb(33, 134, 204)" ],
      [ 0.6, "rgb(42, 166, 212)" ],
      [ 0.7, "rgb(50, 191, 212)" ],
      [ 0.8, "rgb(56, 210, 212)" ],
      [ 0.9, "rgb(62, 229, 212)" ],
      [ 1, "rgb(68, 248, 212)" ],
      [ 1.1, "rgb(71, 244, 197)" ],
      [ 1.2, "rgb(77, 237, 167)" ],
      [ 1.3, "rgb(81, 232, 144)" ],
      [ 1.4, "rgb(86, 226, 121)" ],
      [ 1.5, "rgb(90, 221, 98)" ],
      [ 1.6, "rgb(112, 223, 91)" ],
      [ 1.7, "rgb(142, 229, 92)" ],
      [ 1.8, "rgb(173, 235, 94)" ],
      [ 1.9, "rgb(204, 241, 96)" ],
      [ 2, "rgb(244, 249, 98)" ],
      [ 2.1, "rgb(255, 238, 96)" ],
      [ 2.2, "rgb(255, 217, 90)" ],
      [ 2.3, "rgb(255, 196, 84)" ],
      [ 2.4, "rgb(255, 168, 77)" ],
      [ 2.5, "rgb(255, 147, 71)" ],
      [ 2.6, "rgb(251, 128, 65)" ],
      [ 2.7, "rgb(241, 92, 47)" ],
      [ 2.8, "rgb(234, 64, 33)" ],
      [ 2.9, "rgb(227, 37, 19)" ],
      [ 3, "rgb(220, 10, 5)" ],
      [ 3.1, "rgb(217, 4, 4)" ],
      [ 3.2, "rgb(211, 4, 4)" ],
      [ 3.3, "rgb(208, 3, 3)" ],
      [ 3.4, "rgb(202, 3, 3)" ],
      [ 3.5, "rgb(196, 2, 2)" ],
      [ 3.6, "rgb(191, 2, 2)" ],
      [ 3.7, "rgb(188, 2, 2)" ],
      [ 3.8, "rgb(182, 1, 1)" ],
      [ 3.9, "rgb(179, 1, 1)" ],
      [ 4, "rgb(176, 1, 1)" ],
      [ 4.1, "rgb(180, 8, 12)" ],
      [ 4.2, "rgb(184, 16, 24)" ],
      [ 4.3, "rgb(193, 32, 48)" ],
      [ 4.4, "rgb(202, 48, 72)" ],
      [ 4.5, "rgb(207, 56, 84)" ],
      [ 4.6, "rgb(215, 72, 109)" ],
      [ 4.7, "rgb(224, 88, 133)" ],
      [ 4.8, "rgb(229, 96, 145)" ],
      [ 4.9, "rgb(238, 112, 169)" ],
      [ 5, "rgb(242, 120, 181)" ],
      [ 5.1, "rgb(242, 127, 184)" ],
      [ 5.2, "rgb(243, 136, 189)" ],
      [ 5.3, "rgb(245, 153, 198)" ],
      [ 5.4, "rgb(246, 170, 208)" ],
      [ 5.5, "rgb(247, 178, 212)" ],
      [ 5.6, "rgb(249, 195, 222)" ],
      [ 5.7, "rgb(250, 204, 226)" ],
      [ 5.8, "rgb(251, 221, 236)" ],
      [ 5.9, "rgb(253, 238, 245)" ],
      [ 6, "rgb(254, 246, 250)" ],
      [ 6.1, "rgb(255, 255, 255)" ],
      [ 6.2, "rgb(247, 240, 247)" ],
      [ 6.4, "rgb(238, 224, 239)" ],
      [ 6.5, "rgb(230, 208, 231)" ],
      [ 6.7, "rgb(221, 192, 223)" ],
      [ 6.8, "rgb(213, 176, 215)" ],
      [ 6.9, "rgb(204, 160, 207)" ],
      [ 7, "rgb(196, 144, 199)" ],
      [ 7.1, "rgb(187, 128, 190)" ],
      [ 7.2, "rgb(179, 112, 182)" ],
      [ 7.4, "rgb(170, 96, 174)" ],
      [ 7.5, "rgb(162, 80, 166)" ],
      [ 7.6, "rgb(153, 64, 158)" ],
      [ 7.8, "rgb(145, 48, 150)" ],
      [ 7.9, "rgb(136, 32, 142)" ],
      [ 7.938, "rgb(128, 16, 134)" ]
    ]
  }
};